/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AiOfferDraftItemUser from './AiOfferDraftItemUser';

/**
 * The AiOfferDraftItem model module.
 * @module model/AiOfferDraftItem
 * @version 1.0.0
 */
class AiOfferDraftItem {
    /**
     * Constructs a new <code>AiOfferDraftItem</code>.
     * @alias module:model/AiOfferDraftItem
     * @param id {Number} 
     * @param userId {Number} 
     * @param status {module:model/AiOfferDraftItem.StatusEnum} pending は生成待ち、succeeded は生成成功、failed は生成失敗、 skipped は依頼時に対象外と判定されたもの。
     * @param confirmed {Boolean} 人が内容を確認したか。送信されるのは確認済みの item だけ
     */
    constructor(id, userId, status, confirmed) { 
        
        AiOfferDraftItem.initialize(this, id, userId, status, confirmed);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, userId, status, confirmed) { 
        obj['id'] = id;
        obj['user_id'] = userId;
        obj['status'] = status;
        obj['confirmed'] = confirmed;
    }

    /**
     * Constructs a <code>AiOfferDraftItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferDraftItem} obj Optional instance to populate.
     * @return {module:model/AiOfferDraftItem} The populated <code>AiOfferDraftItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferDraftItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('generated_short_appeal_message')) {
                obj['generated_short_appeal_message'] = ApiClient.convertToType(data['generated_short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('generated_proposal_content')) {
                obj['generated_proposal_content'] = ApiClient.convertToType(data['generated_proposal_content'], 'String');
            }
            if (data.hasOwnProperty('error_code')) {
                obj['error_code'] = ApiClient.convertToType(data['error_code'], 'String');
            }
            if (data.hasOwnProperty('skip_reason')) {
                obj['skip_reason'] = ApiClient.convertToType(data['skip_reason'], 'String');
            }
            if (data.hasOwnProperty('confirmed')) {
                obj['confirmed'] = ApiClient.convertToType(data['confirmed'], 'Boolean');
            }
            if (data.hasOwnProperty('investment_proposal_id')) {
                obj['investment_proposal_id'] = ApiClient.convertToType(data['investment_proposal_id'], 'Number');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = AiOfferDraftItemUser.constructFromObject(data['user']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferDraftItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferDraftItem</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AiOfferDraftItem.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }
        // ensure the json data is a string
        if (data['generated_short_appeal_message'] && !(typeof data['generated_short_appeal_message'] === 'string' || data['generated_short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `generated_short_appeal_message` to be a primitive type in the JSON string but got " + data['generated_short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['generated_proposal_content'] && !(typeof data['generated_proposal_content'] === 'string' || data['generated_proposal_content'] instanceof String)) {
            throw new Error("Expected the field `generated_proposal_content` to be a primitive type in the JSON string but got " + data['generated_proposal_content']);
        }
        // ensure the json data is a string
        if (data['error_code'] && !(typeof data['error_code'] === 'string' || data['error_code'] instanceof String)) {
            throw new Error("Expected the field `error_code` to be a primitive type in the JSON string but got " + data['error_code']);
        }
        // ensure the json data is a string
        if (data['skip_reason'] && !(typeof data['skip_reason'] === 'string' || data['skip_reason'] instanceof String)) {
            throw new Error("Expected the field `skip_reason` to be a primitive type in the JSON string but got " + data['skip_reason']);
        }
        // validate the optional field `user`
        if (data['user']) { // data not null
          AiOfferDraftItemUser.validateJSON(data['user']);
        }

        return true;
    }


}

AiOfferDraftItem.RequiredProperties = ["id", "user_id", "status", "confirmed"];

/**
 * @member {Number} id
 */
AiOfferDraftItem.prototype['id'] = undefined;

/**
 * @member {Number} user_id
 */
AiOfferDraftItem.prototype['user_id'] = undefined;

/**
 * pending は生成待ち、succeeded は生成成功、failed は生成失敗、 skipped は依頼時に対象外と判定されたもの。
 * @member {module:model/AiOfferDraftItem.StatusEnum} status
 */
AiOfferDraftItem.prototype['status'] = undefined;

/**
 * 編集後の訴求文
 * @member {String} short_appeal_message
 */
AiOfferDraftItem.prototype['short_appeal_message'] = undefined;

/**
 * 編集後の本文
 * @member {String} proposal_content
 */
AiOfferDraftItem.prototype['proposal_content'] = undefined;

/**
 * 生成直後の訴求文（原文）
 * @member {String} generated_short_appeal_message
 */
AiOfferDraftItem.prototype['generated_short_appeal_message'] = undefined;

/**
 * 生成直後の本文（原文）
 * @member {String} generated_proposal_content
 */
AiOfferDraftItem.prototype['generated_proposal_content'] = undefined;

/**
 * status=failed のときの失敗理由
 * @member {module:model/AiOfferDraftItem.ErrorCodeEnum} error_code
 */
AiOfferDraftItem.prototype['error_code'] = undefined;

/**
 * status=skipped のときの除外理由
 * @member {module:model/AiOfferDraftItem.SkipReasonEnum} skip_reason
 */
AiOfferDraftItem.prototype['skip_reason'] = undefined;

/**
 * 人が内容を確認したか。送信されるのは確認済みの item だけ
 * @member {Boolean} confirmed
 */
AiOfferDraftItem.prototype['confirmed'] = undefined;

/**
 * 送信で作られた提案。送信されるまで null
 * @member {Number} investment_proposal_id
 */
AiOfferDraftItem.prototype['investment_proposal_id'] = undefined;

/**
 * @member {module:model/AiOfferDraftItemUser} user
 */
AiOfferDraftItem.prototype['user'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
AiOfferDraftItem['StatusEnum'] = {

    /**
     * value: "pending"
     * @const
     */
    "pending": "pending",

    /**
     * value: "succeeded"
     * @const
     */
    "succeeded": "succeeded",

    /**
     * value: "failed"
     * @const
     */
    "failed": "failed",

    /**
     * value: "skipped"
     * @const
     */
    "skipped": "skipped"
};


/**
 * Allowed values for the <code>error_code</code> property.
 * @enum {String}
 * @readonly
 */
AiOfferDraftItem['ErrorCodeEnum'] = {

    /**
     * value: "GEMINI_API_ERROR"
     * @const
     */
    "API_ERROR": "GEMINI_API_ERROR",

    /**
     * value: "GEMINI_TEMPORARY_ERROR"
     * @const
     */
    "TEMPORARY_ERROR": "GEMINI_TEMPORARY_ERROR",

    /**
     * value: "GEMINI_INVALID_RESPONSE"
     * @const
     */
    "INVALID_RESPONSE": "GEMINI_INVALID_RESPONSE",

    /**
     * value: "GEMINI_LENGTH_EXCEEDED"
     * @const
     */
    "LENGTH_EXCEEDED": "GEMINI_LENGTH_EXCEEDED"
};


/**
 * Allowed values for the <code>skip_reason</code> property.
 * @enum {String}
 * @readonly
 */
AiOfferDraftItem['SkipReasonEnum'] = {

    /**
     * value: "already_offered_today"
     * @const
     */
    "already_offered_today": "already_offered_today",

    /**
     * value: "scheduled_exists"
     * @const
     */
    "scheduled_exists": "scheduled_exists",

    /**
     * value: "out_of_scope"
     * @const
     */
    "out_of_scope": "out_of_scope",

    /**
     * value: "canceled"
     * @const
     */
    "canceled": "canceled"
};



export default AiOfferDraftItem;

